// extracted by mini-css-extract-plugin
export var label = "_h5-2";
export var slideContainer = "_h5-0";
export var slider = "_h5-1";